import { CommissionLadderRootPayload } from 'config/requests/comissions';
import omit from 'lodash/omit';

import { CommissionsCreateFormValues } from '../CommissionsCreateForm';

export const transformLadder = (data: CommissionsCreateFormValues): CommissionLadderRootPayload => {
  const rest = omit(data, ['rate']) as Omit<CommissionsCreateFormValues, 'rate'>;

  return {
    ...rest,
    calculationMethod: data.calculationMethod ?? null,
    ladder: data.ladder
      ? {
          ...data.ladder,
          steps: data.ladder.steps?.map((step) => ({
            ...step,
            thresholdFrom: step.thresholdFrom ? step.thresholdFrom + '' : null,
            thresholdTo: step.thresholdTo ? step.thresholdTo + '' : null,
            commissionRate: {
              ...step.commissionRate,
              min: step.commissionRate.min ? step.commissionRate.min + '' : null,
              max: step.commissionRate.max ? step.commissionRate.max + '' : null,
              percent: step.commissionRate.percent ? step.commissionRate.percent + '' : null,
              fix: step.commissionRate.fix ? step.commissionRate.fix + '' : null,
              zeroed: false,
            },
          })),
        }
      : null,
  };
};
